
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Icon","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 1000 1000","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M531.6 876.6h-96v-79.4h156V685.6H435.7v-1.1h-.6V607h.6v-.8h155.9V494.4h-156V415h156V302.5H11.3v686.7h735.3V876.6h-215zM123.9 414.9h198.6v79.4H123.9v-79.4zm198.6 461.7H123.9v-79.4h198.6v79.4zm.4-192.1h-.4v1.1H123.9v-79.4h198.6v.8h.4v77.5z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M804.7 541.4L946 492.8v-54.5l19.6-6.7c15.3-5.3 23.5-22 18.2-37.3-5.3-15.3-22-23.5-37.3-18.2l-.5.2v-.1l-132.2 45.4c-7.3 2.5-15.3-1.4-17.8-8.7-2.5-7.3 1.4-15.3 8.7-17.8L946 346.5V292l19.6-6.7c15.3-5.3 23.5-22 18.2-37.3-5.3-15.3-22-23.5-37.3-18.2l-.5.2v-.1l-132.2 45.4c-7.3 2.5-15.3-1.4-17.8-8.7-2.5-7.3 1.4-15.3 8.7-17.8L946 200.2v-58.5L912.6 113V80.9h-37.4L818 31.7l-62.8 49.2h-31v24.3l-46.5 36.5v180.4l-7.2 2.5c-15.3 5.3-23.5 22-18.2 37.3 3.9 11.4 14.1 18.8 25.4 19.7v86.8l-7.2 2.5c-15.3 5.3-23.5 22-18.2 37.3 3.9 11.4 14.1 18.8 25.4 19.7v86.8l-7.2 2.5c-15.3 5.3-23.5 22-18.2 37.3 3.9 11.4 14.1 18.8 25.4 19.7V761l-7.2 2.5c-15.3 5.3-23.5 22-18.2 37.3 5.3 15.3 22 23.5 37.3 18.2l66.9-23H946v-65.1l19.6-6.7c15.3-5.3 23.5-22 18.2-37.3-5.3-15.3-22-23.5-37.3-18.2l-.5.3v-.1l-132.2 45.4c-7.3 2.5-15.3-1.4-17.8-8.7-2.5-7.3 1.4-15.3 8.7-17.8L946 639.2v-54.5l19.6-6.7c15.3-5.3 23.5-22 18.2-37.3-5.3-15.3-22-23.5-37.3-18.2l-.5.2v-.1L813.8 568c-7.3 2.5-15.3-1.4-17.8-8.7-2.6-7.4 1.3-15.4 8.7-17.9z"}})])
          )
        }
      }
    